<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Michael John is a retired Master Mariner. In a full career at sea he commanded a wide range of ships across the world.</p>
<p style="text-align: center;"><em>Isabella</em> is his second novel of three published books. Much of the historical background has been drawn from family records.</p>
<p style="text-align: center;">Michael John has a daughter, twin sons and seven grandchildren</p>
<p>He sails his own traditional boat and lives on the river Tamar.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3ab250c2